var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M3.844 1.544A1.714 1.714 0 1 0 3.844 4.9719999999999995A1.714 1.714 0 1 0 3.844 1.544Z",
    transform: "rotate(-45.001 3.844 3.258)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M13.137 11.408999999999999A1.143 1.143 0 1 0 13.137 13.695A1.143 1.143 0 1 0 13.137 11.408999999999999Z",
    transform: "rotate(-45.001 13.137 12.552)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M13.137 2.6870000000000003A0.571 0.571 0 1 0 13.137 3.8289999999999997A0.571 0.571 0 1 0 13.137 2.6870000000000003Z",
    transform: "rotate(-45.001 13.137 3.258)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M3.844 11.123A1.429 1.429 0 1 0 3.844 13.981A1.429 1.429 0 1 0 3.844 11.123Z",
    transform: "rotate(-45.001 3.844 12.552)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M8.895 0.8089999999999999A0.429 0.429 0 1 0 8.895 1.667A0.429 0.429 0 1 0 8.895 0.8089999999999999Z",
    transform: "rotate(-45.001 8.895 1.238)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M8.692 13.286A1.286 1.286 0 1 0 8.692 15.857999999999999A1.286 1.286 0 1 0 8.692 13.286Z",
    transform: "rotate(-45.001 8.692 14.572)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M15.157 7.249999999999999A0.857 0.857 0 1 0 15.157 8.963999999999999A0.857 0.857 0 1 0 15.157 7.249999999999999Z",
    transform: "rotate(-45.001 15.158 8.107)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M1.964 6.384A1.561 1.561 0 1 0 1.964 9.506A1.561 1.561 0 1 0 1.964 6.384Z",
    transform: "rotate(-45.001 1.964 7.945)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.eb2390de26a9f45d2b11f0fa60fcb688.svg";
export { ForwardRef as ReactComponent };